import { Row, Tag } from 'antd';
import { Trans } from 'react-i18next';

import { RegistrationFieldType } from '../types';

const isRegistrationFieldVisible = (field: RegistrationFieldType) =>
  field === 'VISIBLE' || field === 'VISIBLE_AND_REQUIRED';

interface RegistrationEnabledFieldsTagsProps {
  fields: {
    cpf: RegistrationFieldType;
    portfolio: RegistrationFieldType;
    pcd: RegistrationFieldType;
    cid: RegistrationFieldType;
    pcd_report: RegistrationFieldType;
    birthday: RegistrationFieldType;
    salary: RegistrationFieldType;
    address: RegistrationFieldType;
    relocation: RegistrationFieldType;
    travel: RegistrationFieldType;
  };
  alwaysRequiredCpf?: boolean;
}

const RegistrationEnabledFieldsTags = ({
  fields,
  alwaysRequiredCpf,
}: RegistrationEnabledFieldsTagsProps) => {
  return (
    <Row gutter={[8, 8]}>
      <Tag>
        <Trans>Nome completo</Trans>
      </Tag>
      <Tag>
        <Trans>E-mail</Trans>
      </Tag>
      <Tag>
        <Trans>Telefone</Trans>
      </Tag>
      <Tag>
        <Trans>Como ficou sabendo da vaga?</Trans>
      </Tag>
      <Tag>LinkedIn</Tag>
      <Tag>
        <Trans>Currículo</Trans>
      </Tag>
      {(alwaysRequiredCpf || isRegistrationFieldVisible(fields.cpf)) && (
        <Tag>
          <Trans>CPF</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.portfolio) && (
        <Tag>
          <Trans>Portfólio / Github / Site</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.pcd) && (
        <Tag>
          <Trans>É PcD?</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.cid) && (
        <Tag>
          <Trans>Inserir CID</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.pcd_report) && (
        <Tag>
          <Trans>Anexar laudo</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.birthday) && (
        <Tag>
          <Trans>Data de Nascimento</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.salary) && (
        <Tag>
          <Trans>Pretensão salarial</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.address) && (
        <Tag>
          <Trans>Endereço (país, estado e cidade)</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.relocation) && (
        <Tag>
          <Trans>Possibilidade de mudança?</Trans>
        </Tag>
      )}
      {isRegistrationFieldVisible(fields.travel) && (
        <Tag>
          <Trans>Aceita viajar pela empresa?</Trans>
        </Tag>
      )}
    </Row>
  );
};

export default RegistrationEnabledFieldsTags;
